// This file is auto-generated by ./bin/rails generate stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application.js"

// Vite-friendly way to load controllers:
import InvoicePollingController from "./invoice_polling_controller.js"
application.register("invoice-polling", InvoicePollingController)

import PaymentTypeController from "./payment_type_controller.js"
application.register("payment-type", PaymentTypeController)

import GroupRegistrationsController from "./group_registrations_controller.js"
application.register("group-registrations", GroupRegistrationsController)

// import PhoneMaskController from "./phone_mask_controller.js"
// application.register("phone-mask", PhoneMaskController)
